// extracted by mini-css-extract-plugin
export var heroImage = "_m2-1";
export var modal = "_m2-0";